import { electronicFormatIBAN, isValidIBAN } from 'ibantools';
import { registerDecorator } from 'class-validator';
export function normalizeIban(value) {
    return electronicFormatIBAN(value) ?? '';
}
export function isIbanValid(value) {
    return isValidIBAN(normalizeIban(value));
}
export function IsValidIban(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isValidIban',
            target: object.constructor,
            propertyName,
            options: { message: 'IBAN is not valid', ...validationOptions },
            validator: {
                validate(value) {
                    return typeof value === 'string' && isIbanValid(value);
                },
            },
        });
    };
}
//# sourceMappingURL=iban.js.map